exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-row[data-v-68c7d570] {\n  margin-bottom: 20px;\n}\n", ""]);

// exports
